// extracted by mini-css-extract-plugin
export default {"loadingComponent":"index_loadingComponent__rMfav","loadingComponentBorder":"index_loadingComponentBorder__yBxCR"};